/** @format */

module.exports = {
  HOST_API_DASHBOARD: "https://kong.traffy.in.th/core-dashboard-api",

  GOOGLE_MAP_KEY: "AIzaSyBNaCkvJVg-ZUZ4MdZ0B6CGCVWH1xrWOo8",
  HOST_API_DASHBOARD_PUBLIC:
    "https://dashboard.traffy.in.th/api_for_core_dashboard_public.php",
  HOST_API_DASHBOARD_PRIVATE:
    "https://dashboard.traffy.in.th/api_for_core_dashboard_private.php",
  HOST_API_DASHBOARD_PRIVATE_PGM:
    "https://dashboard.traffy.in.th/api_for_core_dashboard_pgm.php",
  APITRAFFY: "https://api.traffy.in.th",
  // HOST_API_FONDUE: 'https://neo-fondue.traffy.in.th',
  // HOST_API_FONDUE_V1: 'https://neo-fondue.traffy.in.th/v1',

  HOST_API_FONDUE: "https://kong.traffy.in.th/non-auth",
  HOST_API_FONDUE_V1: "https://kong.traffy.in.th/fondue-auth",
  HOST_API_FONDUE_WRITE_V1: "https://kong.traffy.in.th/fondue-write/v1",
  HOST_API_CHAMP_FONDUE_V1: "https://champ.traffy.in.th/v1",

  HOST_API_FONDUE_QR: "https://qr-fondue.traffy.in.th",
  WEB_VERSION: "0.5.11", // See latest image version here https://console.cloud.google.com/gcr/images/traffy-cloud/asia/fondue_dashboard_and_manager?project=traffy-cloud
  DEVICE_TYPE: "web-report-issue",
  HOST_LINE_LOGIN:
    "https://kong.traffy.in.th/fondue-dashboard-and-manager-line-login/landing.php",
  HOST_REVERSE_GEO: "https://kong.traffy.in.th/fondue-reverse-geo",
  HOST_GOOGLE_MAP: "https://maps.googleapis.com/maps/api",
  // DEFAULT_POST_PHOTO: 'https://storage.googleapis.com/traffy_public_bucket/traffy_logo/broken_img4.png',
  DEFAULT_POST_PHOTO:
    "https://storage.googleapis.com/traffy_public_bucket/dashboard_icon/image_preview.png",
  DEFAULT_USER_PHOTO:
    "https://storage.googleapis.com/traffy_public_bucket/dashboard_icon/missing_user.png",
  DEFAULT_HOME_ICON:
    "https://storage.googleapis.com/traffy_public_bucket/traffy_logo/home1.png",
  TRAFFY_DONDUE_LOGO:
    "https://storage.googleapis.com/traffy_public_bucket/traffy_logo/App%20Icon%20Traffy%20Fondue%20.png",
};
